if (!customElements.get('size-chart-tabs')) {
  class SizeChartTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.size-chart__unit-tab'));
      this.panels = Array.from(this.querySelectorAll('[data-unit-panel]'));
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.selectUnit(tab.dataset.unit));
      });
    }

    selectUnit(unit) {
      this.tabs.forEach((tab) => {
        const isActive = tab.dataset.unit === unit;
        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive);
      });
      this.panels.forEach((panel) => {
        const isActive = panel.dataset.unitPanel === unit;
        panel.classList.toggle('is-active', isActive);
        panel.hidden = !isActive;
      });
    }
  }

  customElements.define('size-chart-tabs', SizeChartTabs);
}

if (!customElements.get('size-chart-opener')) {
  // A custom element (not a one-time querySelectorAll pass) so this keeps
  // working after product-info.js swaps in a freshly-rendered opener on
  // variant change (updateSourceFromDestination('SizeChart')) - connectedCallback
  // re-runs on every insertion, script tags in swapped-in innerHTML don't.
  class SizeChartOpener extends HTMLElement {
    connectedCallback() {
      const button = this.querySelector('button');
      const modal = document.querySelector(this.dataset.modal);
      if (!button || !modal) return;

      const content = modal.querySelector('.size-chart-modal__content');

      // The popup can be opened two ways, each with different chrome:
      // - Click: the classic centered modal with a dimmed, click-catching
      //   backdrop. Deliberate action, so it should be robust and not care
      //   about stray pixels.
      // - Hover (desktop only): a lightweight panel anchored next to the
      //   button. Its backdrop is transparent AND non-interactive
      //   (pointer-events: none), because a backdrop that intercepts the
      //   cursor is what causes it to falsely register the button as
      //   "unhovered" the instant the popup appears, which is what was
      //   making it flicker open/closed.
      function resetToCentered() {
        modal.classList.remove('is-anchored');
        if (content) {
          content.style.position = '';
          content.style.top = '';
          content.style.left = '';
        }
      }

      function positionAnchored() {
        if (!content) return;
        const margin = 16;
        const gap = 8;
        const buttonRect = button.getBoundingClientRect();

        content.style.top = '0px';
        content.style.left = '0px';
        const contentRect = content.getBoundingClientRect();

        let top = buttonRect.bottom + gap;
        if (top + contentRect.height > window.innerHeight - margin) {
          top = Math.max(margin, buttonRect.top - gap - contentRect.height);
        }

        let left = buttonRect.left;
        const maxLeft = window.innerWidth - contentRect.width - margin;
        if (left > maxLeft) left = Math.max(margin, maxLeft);

        content.style.top = `${top}px`;
        content.style.left = `${left}px`;
      }

      button.addEventListener('click', () => {
        resetToCentered();
        modal.show(button);
      });

      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        let openTimer;
        let closeTimer;

        const cancelClose = () => window.clearTimeout(closeTimer);
        const scheduleClose = () => {
          cancelClose();
          closeTimer = window.setTimeout(() => {
            if (modal.hasAttribute('open')) modal.hide();
          }, 250);
        };

        this.addEventListener('mouseenter', () => {
          cancelClose();
          openTimer = window.setTimeout(() => {
            if (!modal.hasAttribute('open')) {
              modal.classList.add('is-anchored');
              modal.show(button);
              positionAnchored();
            }
          }, 200);
        });
        this.addEventListener('mouseleave', () => {
          window.clearTimeout(openTimer);
          scheduleClose();
        });

        if (content) {
          content.addEventListener('mouseenter', cancelClose);
          content.addEventListener('mouseleave', scheduleClose);
        }
      }
    }
  }

  customElements.define('size-chart-opener', SizeChartOpener);
}
